
import React from 'react';

const BackgroundStyles = () => {
  return (
    <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes float-slow {
          0%, 100% { 
            transform: translate(0px, 0px) scale(1); 
            opacity: 0.3;
          }
          25% { 
            transform: translate(15px, -10px) scale(1.02); 
            opacity: 0.4;
          }
          50% { 
            transform: translate(-8px, -15px) scale(0.98); 
            opacity: 0.2;
          }
          75% { 
            transform: translate(-12px, -5px) scale(1.01); 
            opacity: 0.35;
          }
        }
        
        @keyframes pulse-glow {
          0% { 
            filter: blur(15px) brightness(0.8);
            transform: scale(1);
          }
          100% { 
            filter: blur(25px) brightness(1.1);
            transform: scale(1.05);
          }
        }
        
        @keyframes particle-drift {
          0% { 
            transform: translateY(0px) translateX(0px) rotate(0deg); 
            opacity: 0.2;
          }
          25% { 
            opacity: 0.3;
          }
          50% { 
            transform: translateY(-20px) translateX(15px) rotate(90deg); 
            opacity: 0.1;
          }
          75% { 
            opacity: 0.25;
          }
          100% { 
            transform: translateY(-40px) translateX(30px) rotate(180deg); 
            opacity: 0.1;
          }
        }
        
        @keyframes grid-move {
          0% { 
            transform: translate(0, 0);
          }
          100% { 
            transform: translate(20px, 20px);
          }
        }
      `
    }} />
  );
};

export default BackgroundStyles;
